/**
 * Check if a domain operates as a direct brand (own homepage, not a comparison portal).
 * Includes both 'direct' (own product) and 'beratung' (1:1 consulting) modes.
 */
export function isBrandDirect(domain) {
    const mode = domain?.settings?.brand_mode;
    return mode === 'direct' || mode === 'beratung';
}
